import React from 'react';

import { BoldText, DangerText } from './Components/ContractText';

/* we need to make the earnest money deposit contract portion reflect the deposit amount, if there is one or two, and due date. */

interface EarnestMoneyProps {
  deposit1: number;
  deposit1Due: string;
  deposit2?: number;
  deposit2Due?: string;
  titleCompany?: string;
}

const EarnestMoney = ({
  deposit1,
  deposit1Due,
  deposit2,
  deposit2Due,
  titleCompany,
}: EarnestMoneyProps) => {
  // Determine if there are any deposits
  const hasDeposit1 = deposit1 && deposit1 > 0;
  const hasDeposit2 = deposit2 && deposit2 > 0;
  const hasAnyDeposits = hasDeposit1;

  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Earnest Money
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside text-bold">
        {!hasAnyDeposits && (
          <li>
            There is no earnest money deposit or cash deposit on acceptance of
            this contract.
          </li>
        )}

        {hasDeposit1 && (
          <li>
            Buyer shall deposit <BoldText>${deposit1}</BoldText> as earnest
            money deposit with {titleCompany || 'the Title Company'} on or
            before <BoldText>{deposit1Due}</BoldText>.
          </li>
        )}

        {hasDeposit2 && (
          <li>
            Buyer shall deposit <BoldText>${deposit2}</BoldText> as earnest
            money deposit with {titleCompany || 'the Title Company'} on or
            before <BoldText>{deposit2Due}</BoldText>.
          </li>
        )}

        {hasAnyDeposits && (
          <>
            <li>
              If Buyer fails to deposit the earnest money as required by this
              Contract, Seller may terminate this Contract by providing written
              notice to Buyer within 3 days after the deadline for Buyer's
              performance.
            </li>
            <li>
              If Buyer deposits the earnest money as required by this Contract,
              the earnest money shall be applied to the Purchase Price at
              Closing.
            </li>
          </>
        )}
      </ol>
    </div>
  );
};

export default EarnestMoney;
